/**
 * <unit-price-inline> -- keeps the Grundpreis text in the price line in sync with the selected variant.
 */
if (!customElements.get('unit-price-inline')) {
  class UnitPriceInline extends HTMLElement {
    connectedCallback() {
      this.label = this.querySelector('[data-unit-label]');
      try {
        this.labels = JSON.parse(this.querySelector('[data-unit-labels]').textContent);
      } catch (error) {
        this.labels = {};
      }
      this.onVariantChanged = (event) => {
        const id = event.detail?.variant?.id;
        if (!id) return;
        const text = this.labels[String(id)] || '';
        this.label.textContent = text.replace(/ \/ /, '\u00a0/\u00a0');
        this.hidden = !text;
      };
      document.addEventListener('variant:changed', this.onVariantChanged);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.onVariantChanged);
    }
  }
  customElements.define('unit-price-inline', UnitPriceInline);
}
